import Loader from "@/components/Loader";

import React, { useEffect, useState } from "react";
import { useFirestoreConnect } from "react-redux-firebase";

import { useIntraday, WatchlistContext } from "./hooks";
import Watchlist from "./Watchlist";
import { useUserPreference, useWatchListUpdate } from "@/features/applications/hook";

export default () => {
  useFirestoreConnect([{ collection: "exchanges" }, { collection: "intraday" }]);
  const { userPreference } = useUserPreference();
  const [country, setCountry] = useState(userPreference.selectedCountry ? userPreference.selectedCountry : ["SG"]);
  const { userDocName, userWatchlist } = useWatchListUpdate();
  const [activeKey, setActiveKey] = useState(getDefaultActiveKey());
  const { intraday, unfilteredData, watchlistData, lastUpdate } = useIntraday(country, activeKey);

  useEffect(() => {
    if (userDocName.length > 0) setActiveKey(getDefaultActiveKey());
  }, [userDocName]);

  useEffect(() => {
    userPreference.selectedCountry && setCountry(userPreference.selectedCountry)
  }, [userPreference.selectedCountry])

  if (!intraday || userDocName === "") return <Loader />;

  return (
    <WatchlistContext.Provider
      value={{
        lastUpdate,
        unfilteredData,
        watchlistData,
        country,
        setCountry,
        activeKey,
        setActiveKey
      }}
    >
      <Watchlist />
    </WatchlistContext.Provider>
  );

  function getDefaultActiveKey() {
    const lastVisitedWatchlist = userPreference.lastVisitedWatchlist;
    return lastVisitedWatchlist && userWatchlist.hasOwnProperty(lastVisitedWatchlist) ? lastVisitedWatchlist : "all";
  }
};
